import CustomersOrdersPage from './CustomersOrdersPage';
export default CustomersOrdersPage;
